/**
 * The page every Regions screen sits in: the dashboards styling, the page
 * spacing, and the "Regions" heading.
 *
 * These screens used to borrow all of that from the admin dashboards shell.
 * When the shell went away they were left with none of it, and rendered with
 * no padding, no backgrounds and no colours.
 */
import type { ReactNode } from 'react';

import { useViewport } from '../../../../hooks/useViewport';
import { DashboardsPage } from '../../DashboardsPage';
import { DashboardPageHeader } from '../../primitives/DashboardPageHeader';

export function RegionsPage({ children }: { children: ReactNode }) {
  const { isPhone } = useViewport();

  return (
    <DashboardsPage header={<DashboardPageHeader title="Regions" isPhone={isPhone} />}>
      {children}
    </DashboardsPage>
  );
}
